import EnhancedForm from '@runway/enhanced-form';
import Analytics from '@schiphol/analytics';

const APPOINTMENT_DATE_SELECTOR = '#ALT-make_appointment_date_appointmentDay';

export const name = 'appointment-creation';

export default class appointmentCreation extends EnhancedForm {
    get name() {
        return name;
    }

    performSubmit(event) {
        this.appointmentDateSelector = document.querySelector(APPOINTMENT_DATE_SELECTOR);

        Analytics.track({
            event: 'GAEvent',
            eventCategory: 'my schiphol',
            eventAction: 'privium_appointment_date',
            eventLabel: this.appointmentDateSelector.value
        });

        super.performSubmit(event);
    }
}
